var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-wrapper",
    {
      attrs: {
        linkedForm: _vm.linkedForm,
        redirection: _vm.redirectionTo,
        store: _vm.store,
        current: _vm.current,
        labelSaveAndAction: _vm.labelSaveAndAction
      },
      on: { "catch-errors": _vm.catchErrors }
    },
    [
      _c("template", { slot: "title" }, [_vm._v(_vm._s(_vm.formTitle))]),
      _vm._v(" "),
      !_vm.isSingle && _vm.hasCompany && _vm.companyHasName
        ? _c(
            "form-fields-wrapper",
            {
              attrs: {
                field: "company",
                toggleAllowed: false,
                title: _vm.$t.__("common.labels.the_company")
              }
            },
            [
              _c("form-fields-companies-list", {
                staticClass: "mt-3",
                attrs: { company: _vm.company }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form-fields-wrapper",
        {
          attrs: {
            field: "contact",
            toggleAllowed: false,
            title: _vm.$t.__("pages.forms.ThirdContactForm.contact")
          }
        },
        [
          _c("form-fields-contact", {
            ref: "main",
            attrs: { currentStore: _vm.current, error: _vm.error.errors }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "form-fields-wrapper",
        {
          attrs: {
            field: "custom-fields",
            toggleAllowed: false,
            title: _vm.$t.__(
              "pages.forms.ThirdContactForm.contact_custom_fields"
            )
          }
        },
        [
          _c("form-fields-custom-fields", {
            ref: "custom-fields",
            attrs: {
              currentStore: _vm.current,
              error: _vm.error.errors,
              currentCustomfields: _vm.getCustomFields
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }